module.exports = __webpack_public_path__ + "static/instagram-21d65d5f65986b7e2bdebb20b166655d.png";